/***********************
 * Route Pack Protection
 ***********************/

// ===== Config =====
const RP_CONFIG = {
  storage: 'local',     
  persistBy: 'cart',    
  autoAddOnce: true,   
};

// ===== Helpers =====
function rpStorage() {
  try { return RP_CONFIG.storage === 'local' ? window.localStorage : window.sessionStorage; }
  catch { return window.sessionStorage; }
}

function rpKey(kind, token) {
  const scope = (RP_CONFIG.persistBy === 'cart' && token) ? token : 'global';
  return `rp:${kind}:${scope}`;
}

function isVisible(el) {
  if (!el) return false;
  const cs = getComputedStyle(el);
  const rect = el.getBoundingClientRect();
  const hasSize = (rect.width > 0 && rect.height > 0);
  return cs.display !== 'none' && cs.visibility !== 'hidden' && (el.offsetParent !== null || hasSize);
}

function pickDefaultProtectionId(forms, atcs) {
  for (let i = 0; i < forms.length; i++) {
    if (forms[i] && atcs[i] && isVisible(forms[i])) return atcs[i].value;
  }
  return atcs[0]?.value || null;
}

// ===================================================================

function initializeRouteProtection(scope) {
  const context = scope instanceof HTMLElement ? scope : document;

  const forms = context.querySelectorAll('.route-pack-protection_container .route-pack-protection_form');
  const switches = context.querySelectorAll('#route-pack-protection_switch');
  const atcs = context.querySelectorAll('#route-pack-protection_id');

  if (!forms.length || !switches.length || !atcs.length) return;

  fetch(window.Shopify.routes.root + "cart.js")
    .then(response => response.json())
    .then(cart => {
      const token = cart?.token || null; 
      const store = rpStorage();
      const keyAuto   = rpKey('autoadded', token);
      const keyOptOut = rpKey('optout', token);

      switches.forEach((routeProtectionSwitch, i) => {
        const routeProtectionATC = atcs[i];
        if (!routeProtectionSwitch || !routeProtectionATC) return;

        const freshSwitch = routeProtectionSwitch.cloneNode(true);
        routeProtectionSwitch.replaceWith(freshSwitch);

        const routeProtectionItem = cart.items.find(item => item.id === parseInt(routeProtectionATC.value, 10));
        freshSwitch.checked = !!routeProtectionItem;
        freshSwitch.disabled = false;

        freshSwitch.addEventListener("change", function (event) {
          const id = routeProtectionATC.value;
          const qty = event.target.checked ? 1 : 0;

          try {
            if (qty === 0) {
              store.setItem(keyOptOut, '1');   
              store.removeItem(keyAuto);
            } else {
              store.removeItem(keyOptOut);     
              store.setItem(keyAuto, '1');
            }
          } catch {}

          switches.forEach(sw => { if (sw) sw.disabled = true; });
          handleCartAction(id, qty, () => {
            initializeRouteProtection(context);
          });
        });
      });

      const alreadyInCart = (() => {
        const anyId = Array.from(atcs).some(n => cart.items.some(it => it.id === parseInt(n.value, 10)));
        return !!anyId;
      })();

      const optedOut = !!store.getItem(keyOptOut);
      const alreadyAutoAdded = !!store.getItem(keyAuto);

      const shouldAutoAdd =
        !alreadyInCart &&
        !optedOut &&
        (!alreadyAutoAdded || !RP_CONFIG.autoAddOnce);

      if (!window.__rpAutoAddInProgress && shouldAutoAdd) {
        const defaultId = pickDefaultProtectionId(forms, atcs);
        if (defaultId) {
          window.__rpAutoAddInProgress = true;
          switches.forEach(sw => { if (sw) sw.disabled = true; });

          handleCartAction(defaultId, 1, () => {
            try { store.setItem(keyAuto, '1'); } catch {}
            window.__rpAutoAddInProgress = false;
            initializeRouteProtection(context);
          });
        }
      }
    })
    .catch(error => {
      console.error("Error:", error);
    });
}

function handleCartAction(id, qty, callback) {
  const url =
    qty > 0
      ? window.Shopify.routes.root + "cart/add.js"
      : window.Shopify.routes.root + "cart/change.js";

  const body = JSON.stringify(
    qty > 0 ? { items: [{ id: id, quantity: qty }] } : { id: id, quantity: 0 }
  );

  fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: body,
  })
    .then(response => response.json())
    .then(data => {
      publish('cart-update', data);
      document.querySelector('cart-drawer')?.reload();

      const isCartPage = document.body.classList.contains("page-cart");

      if (!isCartPage) {
        fetch('/?sections=cart-notification-product,cart-notification-button,cart-icon-bubble')
          .then(response => response.json())
          .then(sectionsHtml => {
            const lastKey =
              Array.isArray(data?.items) && data.items.length
                ? data.items[data.items.length - 1]?.key
                : undefined;

            document.querySelector('cart-notification')?.renderContents({
              key: lastKey,
              sections: sectionsHtml
            });

            setTimeout(() => {
              initializeRouteProtection(document.querySelector('cart-notification'));
            }, 0);
          })
          .catch(() => {})
          .finally(() => { if (typeof callback === 'function') callback(); });
      } else {
        if (typeof callback === 'function') callback();
      }
    })
    .catch(error => {
      console.error("Error:", error);
      if (typeof callback === 'function') callback();
    });
}

document.addEventListener("DOMContentLoaded", function () {
  initializeRouteProtection();

  subscribe?.('cart-drawer-open', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === "function") {
      drawer.reload();
    }
    initializeRouteProtection(drawer);
  });

  document.addEventListener('cart-drawer-open', () => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.reload === "function") {
      drawer.reload();
    }
    initializeRouteProtection(drawer);
  });

  document.addEventListener('route-protection:init', function () {
    initializeRouteProtection(document.querySelector('cart-notification'));
  });
});
